let accessToken: string | null = null;
const SESSION_CHANNEL_NAME = 'tcgate-auth-session';
const LOGOUT_STORAGE_KEY = 'tcgate:logout-event';
const LOGOUT_EVENT = 'logout';

let sessionChannel: BroadcastChannel | null = null;

const getSessionChannel = () => {
    if (typeof window === 'undefined' || !('BroadcastChannel' in window)) return null;
    try {
        if (!sessionChannel) sessionChannel = new BroadcastChannel(SESSION_CHANNEL_NAME);
    } catch {
        return null;
    }
    return sessionChannel;
};

export const getAccessToken = () => accessToken;

export const setAccessToken = (token: string | null) => {
    accessToken = token;
};

export const clearAccessToken = () => {
    accessToken = null;
};

export const broadcastLogout = () => {
    const channel = getSessionChannel();
    if (channel) {
        channel.postMessage(LOGOUT_EVENT);
        return;
    }

    try {
        localStorage.setItem(LOGOUT_STORAGE_KEY, Date.now().toString());
    } catch {
        // The current tab still logs out if cross-tab storage is unavailable.
    }
};

export const subscribeToLogout = (onLogout: () => void) => {
    const channel = getSessionChannel();
    if (channel) {
        const handleMessage = (event: MessageEvent<unknown>) => {
            if (event.data === LOGOUT_EVENT) onLogout();
        };
        channel.addEventListener('message', handleMessage);
        return () => channel.removeEventListener('message', handleMessage);
    }

    const handleStorage = (event: StorageEvent) => {
        if (event.key === LOGOUT_STORAGE_KEY && event.newValue) onLogout();
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
};
